module.exports = __webpack_public_path__ + "static/media/favicon.a085a69e.ico";


//////////////////
// WEBPACK FOOTER
// ./src/isaver-quote/images/favicon.ico
// module id = 209
// module chunks = 0